import React from 'react';


export const Projects = () => {
    return (
        <>
        <div className = "bg-gray-100 pt-10 m:pt-14">
            <div className="h-box">
                <h1 className="p-head pt-10 m:pt-0 ">Projects</h1>
                <h2 className="main-text">Experience is the best teacher!</h2>
            </div>
        </div>
        </>
    )
};